import Tabs from './Tabs';
import TabPane from './TabPane';
import TabContent from './TabContent';

export default Tabs;
export { TabPane, TabContent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-tabs@9.4.1@rc-tabs/es/index.js
// module id = 1222
// module chunks = 0 1